import { CssBaseline } from "@mui/material";
import { FC, PropsWithChildren } from "react";
import { HelmetProvider } from "react-helmet-async";
import { UserProvider, ThemeProvider, SidebarProvider, TokenProvider } from "../../core/store/context";
;

const AppProviders: FC<PropsWithChildren> = ({ children }) => {
  return (
    <HelmetProvider>
      <ThemeProvider>
        <CssBaseline />
        <TokenProvider>
          <UserProvider>
            <SidebarProvider>{children}</SidebarProvider>
          </UserProvider>
        </TokenProvider>
      </ThemeProvider>
    </HelmetProvider>
  );
};

export default AppProviders;
